export default "__VITE_ASSET__CVn$81pl__"